module.exports = __webpack_public_path__ + "static/media/9DESA30.5fd2e8e5.jpg";